export const hi = {
  // Navigation - मेनू
  nav: {
    dashboard: 'मुख्य पृष्ठ',
    loans: 'लोन',
    borrowers: 'कस्टमर',
    repledging: 'फिर से गिरवी सामान',
    profitability: 'फायदा',
    analytics: 'रिपोर्ट',
    settings: 'सेटिंग',
    support: 'हेल्प',
    profile: 'डिटेल'
  },

  // Common - सामान्य
  common: {
    hello: 'नमस्ते',
    save: 'सेव करें',
    cancel: 'कैंसल करें',
    delete: 'डिलीट करें',
    edit: 'चेंज करें',
    create: 'बनाओ',
    update: 'अपडेट करें',
    search: 'सर्च करें',
    filter: 'फिल्टर करें',
    apply: 'लागू करें',
    actions: 'ऑप्शन',
    loading: 'लोड हो रहा',
    noData: 'कोई डिटेल नहीं',
    confirmDelete: 'हटाने की पुष्टि करें',
    areYouSure: 'क्या आप निश्चित हैं',
    saveChanges: 'बदलाव सेव करें',
    business: 'बिजनेस',
    logout: 'लॉगआउट',
    createNewLoan: 'नया लोन बनाओ',
    createRepledging: 'फिर से गिरवी सामान रखें',
    madeWithLove: 'प्यार से बनाया',
    allRightsReserved: 'सारे अधिकार सुरक्षित',
    developedBy: 'द्वारा बनाया गया',
    developedByCompany: 'Seervi Tech Labs द्वारा बनाया गया',
    unknown: 'पता नहीं',
    results: 'कुल',
    prev: 'पिछला',
    next: 'अगला',
    page: 'पेज',
    gallery: 'गैलरी',
    camera: 'कैमरा',
    chooseFromGallery: 'गैलरी से चुनें',
    takePhoto: 'कैमरा से फोटो लें',
    switchToDark: 'डार्क मोड',
    switchToLight: 'लाइट मोड',
    // Amount and Money related
    amount: 'अमाउंट',
    total: 'टोटल',
    balance: 'बैलेंस',
    paid: 'दिया',
    due: 'बाकी',
    received: 'मिला',
    given: 'दिया',
    debit: 'जमा',
    credit: 'क्रेडिट',
    ledger: 'अकाउंट',
    khata: 'अकाउंट बही',
    transaction: 'ट्रांजैक्शन',
    transactions: 'ट्रांजैक्शन'
  },

  // Settings Page - सेटिंग पृष्ठ
  settings: {
    title: 'सेटिंग',
    todayRates: 'आज के भाव',
    loanSettings: 'लोन की सेटिंग',
    pledgeSettings: 'गिरवी सामान की सेटिंग',
    notifications: 'सूचनाएं',
    language: 'लैंग्वेज',
    appearance: 'दिखावट',
    selectTheme: 'थीम चुनें',
    themeDescription: 'एप के लिए लाइट या डार्क मोड चुनें',
    lightThemeHint: 'दिन में इस्तेमाल के लिए उजाला बैकग्राउंड',
    darkThemeHint: 'कम रोशनी में इस्तेमाल के लिए डार्क बैकग्राउंड',
    createLoanSetting: 'लोन सेटिंग बनाओ',
    createPledgeSetting: 'गिरवी सामान सेटिंग बनाओ',
    metal: 'धातु',
    interestRate: 'ब्याज दर (% प्रति महीना)',
    amount: 'अमाउंट',
    amountRange: 'अमाउंट की सीमा',
    name: 'नाम',
    allMetals: 'सभी धातु',
    gold: 'सोना',
    silver: 'चांदी',
    searchPlaceholder: 'धातु, अमाउंट या ब्याज से सर्च करें...',
    noSettingsFound: 'कोई सेटिंग नहीं मिली',
    noMatchingSettings: 'आपकी खोज से कोई सेटिंग नहीं मिली',
    clickToAdd: 'जोड़ने के लिए यहाँ दबाएं',
    loadingSettings: 'सेटिंग लोड हो रही है...',
    editInterestRate: 'ब्याज दर चेंज करें',
    deleteSetting: 'सेटिंग डिलीट करें',
    createLoanInterestSetting: 'लोन ब्याज सेटिंग बनाओ',
    createNewPledgeSetting: 'नई गिरवी सामान सेटिंग बनाओ',
    editLoanSetting: 'लोन सेटिंग चेंज करें',
    minPlaceholder: 'न्यूनतम (जैसे 1000)',
    maxPlaceholder: 'अधिकतम (जैसे 10000)',
    enterName: 'नाम लिखें',
    interestRatePlaceholder: 'जैसे 2.0',
    settingCreatedSuccess: 'सेटिंग सफलतापूर्वक बनाई गई',
    settingUpdatedSuccess: 'सेटिंग सफलतापूर्वक बदली गई',
    settingDeletedSuccess: 'सेटिंग सफलतापूर्वक हटाई गई',
    createSettingBtn: 'सेटिंग बनाओ',
    creatingSetting: 'बनाया जा रहा है...',
    updateBtn: 'चेंज करें',
    smsWhatsappTemplates: 'संदेश के नमूने',
    loanExpiryReminder: 'लोन समाप्ति की याद',
    paymentConfirmation: 'भुगतान की पुष्टि',
    selectLanguage: 'लैंग्वेज चुनें',
    languageDescription: 'अपनी पसंद की लैंग्वेज चुनें',
    english: 'अंग्रेज़ी',
    hindi: 'हिंदी',
    marwadi: 'मारवाड़ी',
    languageUpdated: 'लैंग्वेज सफलतापूर्वक बदली गई',
    // Today's Gold Rates - आज के भाव
    todayRatesTitle: 'सोना-चांदी के आज के भाव',
    createTodayRate: 'भाव जोड़ें',
    goldType: 'धातु का प्रकार',
    todayValue: 'आज की कीमत (₹)',
    perGramValue: '10 ग्राम के',
    selectGoldType: 'धातु प्रकार चुनें',
    gold24K: '24 कैरेट सोना',
    goldSilver: 'चांदी',
    calculatedFrom24K: '24 कैरेट से गणना',
    gold22K: '22 कैरेट सोना',
    gold18K: '18 कैरेट सोना',
    rateValue: 'भाव',
    createRateBtn: 'भाव जोड़ें',
    editRate: 'भाव चेंज करें',
    deleteRate: 'भाव डिलीट करें',
    createNewRate: 'नया भाव जोड़ें',
    editRateTitle: 'भाव चेंज करें',
    noRatesFound: 'कोई भाव नहीं मिला',
    rateCreatedSuccess: 'भाव सफलतापूर्वक जोड़ा गया',
    rateUpdatedSuccess: 'भाव सफलतापूर्वक बदला गया',
    rateDeletedSuccess: 'भाव सफलतापूर्वक हटाया गया'
  },

  // Dashboard - मुख्य पृष्ठ
  dashboard: {
    title: 'मुख्य पृष्ठ',
    quickValuation: 'त्वरित कीमत',
    quickValuationCalculator: 'त्वरित कीमत कैलटोटलेटर',
    closedLoans: 'बंद लोन',
    todayClosedLoans: 'आज बंद लोन',
    createdLoans: 'टोटल लोन',
    todayCreatedLoans: 'आज नए लोन',
    overdueAccounts: 'बाकी खाते',
    activeLoans: 'चालू लोन',
    inHandGold: 'दुकान में सोना',
    pledgedGold: 'गिरवी सामान सोना',
    awaitingCollection: 'इंतज़ार में',
    interestEarned: 'टोटल ब्याज',
    totalInterestEarned: 'टोटल ब्याज मिला',
    lateFees: 'जुर्माना',
    lateFeesCollected: 'जुर्माना मिला',
    averageLoanSize: 'औसत लोन अमाउंट',
    thisMonth: 'इस महीने',
    activeLoansSubtitle: 'चालू लोन',
    expiringLoans: 'समाप्त होने वाले लोन',
    loansNearingExpiry: 'जल्दी समाप्त होने वाले लोन (अगले 30 दिन)',
    overduePayments: 'बाकी भुगतान',
    recentOverduePayments: 'हाल के बाकी भुगतान',
    collateralDashboard: 'गिरवी सामान डैशबोर्ड',
    loanId: 'लोन नंबर',
    customerName: 'कस्टमर का नाम',
    amount: 'अमाउंट',
    expiryDate: 'समाप्ति की तारीख',
    daysOverdue: 'बाकी दिन',
    viewDetails: 'पूरा विवरण',
    noExpiringLoans: 'अगले 30 दिनों में कोई लोन समाप्त नहीं हो रहा',
    noOverduePayments: 'कोई बाकी भुगतान नहीं',
    refresh: 'फिर से देखें',
    purity: 'शुद्धता',
    netWeight: 'शुद्ध वजन (ग्राम)',
    lendingRate: 'लोन दर (प्रति ग्राम)',
    maxLoanValue: 'अधिकतम लोन अमाउंट',
    calculate: 'गणना करें',
    close: 'बंद करें',
    grams: 'ग्राम',
    perGram: 'प्रति ग्राम',
    // Collateral Details
    inHandOffice: 'दुकान में (ऑफिस)',
    pledged: 'गिरवी सामान',
    awaitingRelease: 'वापसी का इंतज़ार',
    packets: 'पैकेट',
    loanValue: 'लोन की अमाउंट',
    maximumLoanValue: 'अधिकतम लोन अमाउंट',
    viewAll: 'सभी देखें',
    viewLoan: 'लोन देखें',
    noExpiringLoansCaughtUp: 'बहुत अच्छा! अगले 30 दिनों में कोई लोन समाप्त नहीं हो रहा। सब ठीक है।',
    goodMorning: 'सुप्रभात',
    goodAfternoon: 'नमस्कार',
    goodEvening: 'शुभ संध्या',
    heroSubtitle: 'आज आपके बिज़नेस में क्या हो रहा है, यहाँ देखें।',
    businessHealth: 'बिज़नेस हेल्थ',
    healthGood: 'अच्छा',
    healthGoodHint: 'आप अच्छा प्रदर्शन कर रहे हैं',
    healthFair: 'ठीक-ठाक',
    healthFairHint: 'कुछ खातों पर ध्यान दें',
    healthAttention: 'ध्यान दें',
    healthAttentionHint: 'बाकी खातों का फॉलो-अप जरूरी है',
    totalActiveLoans: 'कुल चालू लोन',
    requireAttention: 'ध्यान चाहिए',
    interestEarnedChip: 'ब्याज (इस महीने)',
    customers: 'कस्टमर',
    totalLoans: 'कुल लोन',
    activeLabel: 'सक्रिय',
    vsYesterday: 'कल की तुलना में',
    vsLastMonth: 'पिछले महीने की तुलना में',
    fromLastMonth: 'पिछले महीने से'
  },

  // Login Page - प्रवेश पृष्ठ
  login: {
    title: 'प्रवेश',
    signIn: 'अंदर आएं',
    signUp: 'पंजीकरण करें',
    email: 'ईमेल',
    password: 'पासवर्ड',
    firstName: 'पहला नाम',
    lastName: 'उपनाम',
    loginBtn: 'लॉगिन करें',
    signUpBtn: 'पंजीकरण करें',
    dontHaveAccount: 'अकाउंट नहीं है?',
    alreadyHaveAccount: 'पहले से अकाउंट है?',
    signUpHere: 'यहां पंजीकरण करें',
    signInHere: 'यहां लॉगिन करें',
    welcomeBack: 'फिर से स्वागत है!',
    createAccount: 'अपना अकाउंट बनाओ',
    modernLMS: 'आधुनिक लोन प्रबंधन सॉफ्टवेयर',
    comprehensiveSolution: 'लोन और कस्टमरों के प्रबंधन के लिए पूर्ण समाधान',
    features: {
      loanManagement: 'लोन प्रबंधन',
      borrowerTracking: 'कस्टमर रिकॉर्ड',
      collateralManagement: 'गिरवी सामान प्रबंधन',
      profitabilityAnalysis: 'फायदा विश्लेषण',
      advancedAnalytics: 'विस्तृत रिपोर्ट',
      secureReliable: 'सुरक्षित और भरोसेमंद'
    },
    featureDescriptions: {
      loanManagement: 'सभी लोनों को आसानी से संभालें',
      borrowerTracking: 'सभी कस्टमरों का पूरा विवरण रखें',
      collateralManagement: 'गिरवी सामान सामान की डिटेल रखें',
      profitabilityAnalysis: 'अपने बिजनेस का फायदा देखें',
      advancedAnalytics: 'विस्तृत रिपोर्ट से डिटेल पाएं',
      secureReliable: 'आपका डेटा पूरी तरह सुरक्षित है'
    },
    logoutSuccess: 'सफलतापूर्वक बाहर निकले!',
    sessionExpired: 'आपका सेशन समाप्त हो गया है। कृपया फिर से लॉगिन करें।',
    businessSetup: 'बिजनेस की डिटेल',
    businessName: 'दुकान का नाम',
    contactNumber: 'मोबाइल नंबर',
    address: 'पता',
    businessEmail: 'बिजनेस ईमेल (वैकल्पिक)',
    continue: 'आगे बढ़ें',
    backToSignUp: 'पंजीकरण पर वापस'
  },

  // Borrowers Page - कस्टमर पृष्ठ
  borrowers: {
    title: 'कस्टमर',
    listTitle: 'सभी कस्टमर',
    createNewBorrower: 'नया कस्टमर जोड़ें',
    searchPlaceholder: 'कस्टमर सर्च करें...',
    searchPlaceholderTable: 'नाम या फोन से सर्च करें',
    addBorrower: 'कस्टमर जोड़ें',
    name: 'नाम',
    phone: 'मोबाइल',
    email: 'ईमेल',
    address: 'पता',
    activeLoans: 'चालू लोन',
    totalBorrowed: 'टोटल लोन अमाउंट',
    viewDetails: 'पूरा विवरण',
    noBorrowersFound: 'कोई कस्टमर नहीं मिला',
    loadingBorrowers: 'कस्टमर लोड हो रहे हैं...',
    tableHeaders: {
      index: 'क्रमांक',
      name: 'नाम',
      fatherName: 'पिता/पति का नाम',
      phone: 'मोबाइल',
      email: 'ईमेल',
      address: 'पता',
      idProofType: 'पहचान पत्र का प्रकार',
      idNumber: 'पहचान पत्र नंबर',
      viewId: 'पहचान पत्र देखें',
      actions: 'ऑप्शन'
    },
    tooltips: {
      viewId: 'पहचान पत्र देखें',
      edit: 'कस्टमर चेंज करें',
      delete: 'कस्टमर डिलीट करें'
    },
    tableLabels: {
      noProof: 'उपलब्ध नहीं'
    },
    pagination: {
      label: 'पृष्ठ',
      of: 'में से',
      prev: 'पिछला',
      next: 'अगला'
    },
    deleteModal: {
      title: 'पुष्टि करें',
      messageStart: 'क्या आप सच में हटाना चाहते हैं',
      cancel: 'कैंसल करें',
      confirm: 'डिलीट करें'
    },
    editModal: {
      title: 'कस्टमर चेंज करें',
      close: 'बंद करें'
    },
    form: {
      fullNameLabel: 'पूरा नाम *',
      fatherNameLabel: 'पिता/पति का नाम *',
      contactNumberLabel: 'मोबाइल नंबर *',
      idProofTypeLabel: 'पहचान पत्र का प्रकार *',
      selectIdProofType: 'पहचान पत्र चुनें',
      idProofNumberLabel: 'पहचान पत्र नंबर *',
      emailLabel: 'ईमेल',
      addressLabel: 'पता *',
      uploadTitle: 'पहचान पत्र की फोटो (अधिकतम 2)',
      currentPhotosTitle: 'मौजूदा फोटो:',
      uploadHint: 'नई फोटो डालने के लिए यहाँ दबाएं',
      uploadLimit: 'JPEG, PNG (अधिकतम 5MB)',
      newPhotoLabel: 'नई',
      removePhoto: 'फोटो डिलीट करें'
    },
    upload: {
      maxPhotosError: 'अधिकतम 2 फोटो ही जोड़ सकते हैं',
      invalidFileType: 'कृपया सही फोटो चुनें (JPEG, PNG)',
      fileTooLarge: 'हर फोटो 5MB से कम होनी चाहिए',
      success: 'फोटो सफलतापूर्वक डाली गई!',
      failure: 'फोटो डालने में दिक्कत आई',
      selectedSuffix: 'नई फोटो चुनी गई'
    },
    buttons: {
      cancel: 'कैंसल करें',
      update: 'कस्टमर चेंज करें'
    },
    status: {
      uploading: 'फोटो डाली जा रही है...'
    },
    toast: {
      updateSuccess: 'कस्टमर बदल गया',
      updateError: 'कस्टमर नहीं बदला',
      deleteSuccess: 'कस्टमर हटाया गया',
      deleteError: 'कस्टमर हटाने में दिक्कत आई',
      loadError: 'कस्टमर लोड नहीं हो पाए'
    },
    imageModal: {
      noImages: 'कोई पहचान पत्र की फोटो नहीं',
      failedToLoad: 'फोटो लोड नहीं हो पाई'
    }
  },

  // Loans Page - लोन पृष्ठ
  loans: {
    title: 'सभी लोन',
    loanId: 'लोन नंबर',
    borrowerName: 'कस्टमर का नाम',
    amount: 'अमाउंट',
    interestRate: 'ब्याज दर',
    startDate: 'शुरू होने की तारीख',
    endDate: 'समाप्ति की तारीख',
    status: 'स्थिति',
    actions: 'ऑप्शन',
    active: 'चालू',
    closed: 'बंद',
    overdue: 'बाकी',
    viewDetails: 'पूरा विवरण',
    noLoansFound: 'कोई लोन नहीं मिला',
    searchPlaceholder: 'लोन सर्च करें...',
    filterByStatus: 'स्थिति से फिल्टर करें',
    allLoans: 'सभी लोन',
    searchByLoanPlaceholder: 'लोन नंबर, ID या कस्टमर से सर्च करें',
    serialSearchPlaceholder: 'सीरियल नंबर से सर्च करें',
    dateFilterLabel: 'तारीख',
    dateFieldLabel: 'तारीख',
    allStatus: 'सभी स्थिति',
    filterAction: 'फ़िल्टर',
    resetAction: 'रीसेट',
    todayLabel: 'आज',
    dateFilterOptions: {
      all: 'सभी तारीखें',
      date: 'एक तारीख',
      month: 'महीने से',
      year: 'साल से',
      range: 'तारीख सीमा'
    },
    dateTips: {
      single: 'उस दिन के लोन देखने के लिए तारीख चुनें।',
      range: 'सीमा में लोन देखने के लिए शुरू और अंत तारीख चुनें।',
      month: 'उस महीने के लोन देखने के लिए महीना चुनें।',
      year: 'उस साल के लोन देखने के लिए साल चुनें।'
    },
    fromDateLabel: 'से',
    toDateLabel: 'तक',
    clearDateFilter: 'साफ़',
    closeDateFilter: 'बंद करें',
    statusFilterLabel: 'स्थिति',
    collateralFilterLabel: 'गिरवी सामान स्थिति',
    statusOptions: {
      all: 'सभी',
      awaited: 'आने वाला',
      active: 'चालू',
      completed: 'पूरा'
    },
    collateralStatusOptions: {
      all: 'सभी',
      inHand: 'दुकान में',
      pledged: 'गिरवी सामान',
      awaiting: 'इंतज़ार में',
      handover: 'वापस दिया'
    },
    tableHeaders: {
      loanId: 'लोन नंबर',
      serialNumber: 'सीरियल नंबर',
      customer: 'कस्टमर',
      relation: 'पिता/पति का नाम',
      contactNumber: 'मोबाइल नंबर',
      principal: 'मूल अमाउंट (₹)',
      status: 'स्थिति',
      collateralStatus: 'गिरवी सामान स्थिति',
      packetPlace: 'पैकेट की जगह',
      created: 'बनने की तारीख',
      actions: 'ऑप्शन'
    },
    loadingMessage: 'लोन लोड हो रहे हैं...',
    emptyFiltered: 'आपकी खोज से कोई लोन नहीं मिला',
    toast: {
      deleteSuccess: 'लोन हटा दिया',
      deleteError: 'लोन नहीं हटा'
    },
    messages: {
      loadError: 'लोन लोड नहीं हो पाए',
      searchMinChars: 'खोज के लिए कम से कम 2 अक्षर लिखें'
    },
    deleteModal: {
      title: 'पुष्टि करें',
      messageStart: 'क्या आप यह लोन हटाना चाहते हैं',
      warning: 'इससे जुड़े सभी गिरवी सामान रिकॉर्ड और भुगतान भी हट जाएंगे।',
      cancel: 'कैंसल करें',
      confirm: 'डिलीट करें'
    },
    tooltips: {
      delete: 'लोन डिलीट करें'
    },
    statusLabels: {
      awaited: 'आने वाला',
      active: 'चालू',
      completed: 'पूरा',
      default: 'आने वाला'
    },
    collateralStatusLabels: {
      inHand: 'दुकान में',
      pledged: 'गिरवी सामान',
      awaiting: 'इंतज़ार में',
      handover: 'वापस दिया',
      default: 'पता नहीं'
    },
    labels: {
      serialMissing: '-',
      na: 'पता नहीं'
    }
  },

  // Profile Page - डिटेल पृष्ठ
  // Support Page - हेल्प पृष्ठ
  // Create Borrower Page - नया कस्टमर बनाओ
  createBorrower: {
    title: 'नया कस्टमर बनाओ',
    backToList: 'कस्टमर सूची में वापस',
    // Form Fields
    fullName: 'पूरा नाम',
    fullNamePlaceholder: 'पूरा नाम दर्ज करें',
    fatherHusbandName: 'पिता/पति/आश्रित का नाम',
    fatherHusbandNamePlaceholder: 'पिता/पति/आश्रित का नाम दर्ज करें',
    phoneNumber: 'फोन नंबर',
    phoneNumberPlaceholder: 'फोन नंबर दर्ज करें',
    idProofType: 'आईडी प्रूफ प्रकार',
    aadhaarCard: 'आधार कार्ड',
    panCard: 'पैन कार्ड',
    voterId: 'वोटर आईडी',
    drivingLicense: 'ड्राइविंग लाइसेंस',
    idProofNumber: 'आईडी प्रूफ नंबर',
    idProofNumberPlaceholder: 'आईडी नंबर दर्ज करें',
    email: 'ईमेल पता (वैकल्पिक)',
    emailPlaceholder: 'ईमेल पता दर्ज करें',
    fullAddress: 'पूरा पता',
    fullAddressPlaceholder: 'पूरा पता दर्ज करें',
    uploadIdProof: 'आईडी प्रूफ फोटो अपलोड करें (अधिकतम 2)',
    clickToUpload: 'फोटो अपलोड के लिए क्लिक करें',
    supportedFormats: 'JPEG, PNG (अधिकतम 5MB प्रत्येक)',
    // Buttons
    saveBorrower: 'कस्टमर सेव करें',
    saving: 'सुरक्षित हो रहा है...',
    cancel: 'कैंसल करें',
    // Messages
    borrowerCreatedSuccess: 'कस्टमर सफलतापूर्वक बनाया गया!',
    uploadFailed: 'फोटो अपलोड विफल',
    fillAllFields: 'कृपया सभी आवश्यक फ़ील्ड भरें'
  },

  support: {
    title: 'हेल्प',
    subtitle: 'जब आपको हमारी जरूरत हो, हम हमेशा आपके करीब हैं। अपने सवाल के लिए सबसे उपयुक्त संपर्क ऑप्शन चुनें—चाहे वह डेटा स्पष्टीकरण हो या गहरी तकनीकी समस्या।',
    dataAccountAssistance: 'डेटा और अकाउंट सहायता',
    dataAccountDesc: 'कस्टमर डेटा, लोन रिकॉर्ड, या अकाउंट प्रबंधन से संबंधित सवाल। महेंद्र व्यवसाय के घंटों के दौरान किसी भी परिचालन सवाल को हल करने के लिए उपलब्ध हैं।',
    primaryContact: 'प्राथमिक संपर्क',
    platformTechnicalSupport: 'प्लेटफॉर्म और तकनीकी सहायता',
    platformTechnicalDesc: 'लॉगिन समस्याएं, ऐप एरर, या परफॉर्मेंस की चिंताएं? त्वरित समाधान के लिए Seervi Tech Labs इंजीनियरिंग डेस्क से संपर्क करें।',
    technicalDesk: 'तकनीकी डेस्क',
    getHelp: 'हेल्प लें',
    contactUs: 'हमसे संपर्क करें',
    email: 'ईमेल',
    phone: 'फोन',
    businessHours: 'काम के घंटे',
    mondayToFriday: 'सोमवार से शुक्रवार: सुबह 9:00 - शाम 6:00',
    faq: 'अक्सर पूछे जाने वाले सवाल',
    sendMessage: 'संदेश भेजें',
    yourMessage: 'आपका संदेश',
    messageSent: 'संदेश सफलतापूर्वक भेजा गया'
  },

  // Profitability Page - फायदा पृष्ठ
  profitability: {
    title: 'फायदा',
    purpose: 'मेरे बिजनेस ने असल में कितना पैसा कमाया?',
    businessSummary: 'बिज़नेस सारांश',
    summaryLastMonth: 'पिछले महीने',
    summaryLastQuarter: 'पिछली तिमाही',
    summaryLastYear: 'पिछले साल',
    summaryPriorPeriod: 'पिछली अवधि',
    summaryProfitIncreased: 'फायदा {period} की तुलना में {percent}% बढ़ा।',
    summaryProfitDecreased: 'फायदा {period} की तुलना में {percent}% घटा।',
    summaryProfitUnchanged: 'फायदा {period} की तुलना में समान है।',
    summaryNetProfit: 'इस अवधि का शुद्ध फायदा {amount} है।',
    summaryOutstandingInterest: 'बाकी ब्याज {amount} है।',
    summaryHighestMonth: 'सबसे ज्यादा कमाई का महीना {month} है ({amount})।',
    thisMonth: 'इस महीने',
    thisQuarter: 'इस तिमाही',
    thisYear: 'इस साल',
    allTime: 'सभी',
    grossIncome: 'टोटल आमदनी',
    totalExpenses: 'टोटल खर्च (बैंक ब्याज)',
    netProfit: 'शुद्ध फायदा',
    netLoss: 'शुद्ध नुकसान',
    fromLastMonth: 'पिछले महीने से',
    fromLastQuarter: 'पिछली तिमाही से',
    fromLastYear: 'पिछले साल से',
    fromPriorPeriod: 'पिछली अवधि से',
    interestEarned: 'ब्याज आमदनी',
    pledgeInterestPaid: 'बैंक ब्याज खर्च',
    bankInterestPaid: 'बैंक ब्याज खर्च',
    profitMargin: 'फायदा प्रतिशत',
    month: 'महीना',
    financialPosition: 'वित्तीय स्थिति',
    moneyWithCustomers: 'कस्टमर के पास पैसा',
    moneyBorrowedFromBank: 'बैंक से उधार',
    ownCapitalInvested: 'अपनी पूंजी',
    outstandingInterestYetToCollect: 'बाकी ब्याज',
    profitInsights: 'फायदा जानकारी',
    highestProfitMonth: 'सबसे ज्यादा फायदा महीना',
    lowestProfitMonth: 'सबसे कम फायदा महीना',
    averageMonthlyProfit: 'औसत मासिक फायदा',
    totalProfitSelected: 'कुल फायदा (चयनित अवधि)',
    monthlyFinancialTable: 'मासिक वित्तीय तालिका',
    monthlyRevenue: 'मासिक आमदनी',
    viewReport: 'रिपोर्ट देखें',
    monthlyProfitabilityTrend: 'मासिक फायदाप्रदता रुझान',
    monthlyBreakdownOverview: 'मासिक विवरण सारांश',
    noChartData: 'चयनित अवधि के लिए कोई चार्ट डेटा उपलब्ध नहीं'
  },

  // Analytics Page - रिपोर्ट पृष्ठ
  analytics: {
    title: 'रिपोर्ट और विश्लेषण',
    purpose: 'मेरा बिजनेस कितना स्वस्थ और कुशल है?',
    businessSummary: 'बिज़नेस सारांश',
    businessPerformance: 'बिज़नेस परफॉर्मेंस',
    portfolioHealth: 'पोर्टफोलियो हेल्थ',
    riskLow: 'कम',
    riskMedium: 'मध्यम',
    riskHigh: 'ज्यादा',
    summaryCollectionRate: 'वसूली दर {percent}% है।',
    summaryPortfolioRisk: 'पोर्टफोलियो जोखिम {level} है।',
    summaryOverdueOne: '{count} लोन ओवरड्यू है।',
    summaryOverdueMany: '{count} लोन ओवरड्यू हैं।',
    summaryActivePortfolio: 'एक्टिव पोर्टफोलियो वैल्यू {amount} है।',
    summaryLoanGrowthUp: 'लोन ग्रोथ पिछली अवधि की तुलना में {percent}% बढ़ी।',
    summaryLoanGrowthDown: 'लोन ग्रोथ पिछली अवधि की तुलना में {percent}% घटी।',
    summaryLoanGrowthFlat: 'लोन ग्रोथ पिछली अवधि की तुलना में समान है।',
    last7Days: 'पिछले 7 दिन',
    last30Days: 'पिछले 30 दिन',
    last90Days: 'पिछले 90 दिन',
    lastYear: 'पिछला साल',
    exportReport: 'रिपोर्ट निर्यात करें',
    loanGrowth: 'लोन ग्रोथ',
    activePortfolioValue: 'एक्टिव पोर्टफोलियो वैल्यू',
    collectionRate: 'वसूली दर',
    riskScore: 'जोखिम स्कोर',
    portfolioSummary: 'पोर्टफोलियो सारांश',
    activeLoans: 'एक्टिव लोन',
    completedLoans: 'पूरे हुए लोन',
    overdueLoans: 'ओवरड्यू लोन',
    outstandingPrincipal: 'बाकी मूलधन',
    collectionPerformance: 'वसूली परफॉर्मेंस',
    collections: 'वसूली',
    recoveryRate: 'रिकवरी दर',
    latePayments: 'देर से पेमेंट',
    customerInsights: 'कस्टमर जानकारी',
    newCustomers: 'नए कस्टमर',
    repeatCustomers: 'दोबारा कस्टमर',
    averageLoanSize: 'औसत लोन साइज',
    loanStatusDistribution: 'लोन स्टेटस वितरण',
    awaited: 'प्रतीक्षित',
    active: 'एक्टिव',
    completed: 'पूर्ण',
    totalRevenue: 'टोटल आमदनी',
    newLoans: 'नए लोन',
    revenueTrend: 'आमदनी का रुझान',
    detailedPerformanceReport: 'विस्तृत प्रदर्शन रिपोर्ट',
    comprehensiveAnalysis: 'लोन प्रदर्शन और वित्तीय मेट्रिक्स का व्यापक विश्लेषण',
    metric: 'मेट्रिक',
    currentPeriod: 'वर्तमान अवधि',
    previousPeriod: 'पिछली अवधि',
    change: 'परिवर्तन'
  },

  // Create Loan Page - नया लोन बनाओ
  createLoan: {
    title: 'नया लोन बनाओ',
    subtitle: 'नया लोन बनाने के लिए चरणों का पालन करें।',
    // Steps
    steps: {
      borrower: 'कस्टमर',
      collateral: 'गिरवी सामान',
      terms: 'शर्तें',
      confirm: 'पुष्टि करें'
    },
    // Common Units
    units: {
      grams: 'ग्राम',
      perGram: 'प्रति ग्राम',
      perMonth: 'प्रति महीना',
      months: 'महीने',
      rupees: '₹'
    },
    // Step 1: Borrower Selection
    step1: {
      title: 'चरण 1: कस्टमर चुनें या बनाओ',
      searchExistingBorrower: 'मौजूदा कस्टमर सर्च करें',
      searchPlaceholder: 'नाम या फोन नंबर लिखना शुरू करें...',
      selectedBorrower: 'चुना गया कस्टमर',
      name: 'नाम',
      phone: 'फोन',
      email: 'ईमेल',
      orNewCustomer: 'या, अगर यह नया कस्टमर है:',
      createNewBorrower: 'नया कस्टमर बनाओ'
    },
    // Step 2: Collateral Details
    step2: {
      title: 'चरण 2: गिरवी सामान विवरण',
      loanFor: 'लोन किसके लिए',
      todayMarketRates: '📊 आज के बाजार भाव',
      gold24k: '24 कैरेट सोना (10 ग्राम)',
      gold22k: '22 कैरेट सोना (10 ग्राम)',
      gold18k: '18 कैरेट सोना (10 ग्राम)',
      silver: 'चांदी (1 किलो)',
      serialNumber: 'सीरियल नंबर (वैकल्पिक)',
      serialNumberPlaceholder: 'जैसे: SN123456',
      creatingDate: 'लोन बनाने की तारीख',
      metalType: 'धातु का प्रकार',
      gold: 'सोना',
      silverOption: 'चांदी',
      itemDescription: 'सामान का विवरण',
      itemDescriptionPlaceholder: 'गिरवी सामान का विवरण (जैसे: सोने की चेन, चांदी की चूड़ियां)',
      purity: 'शुद्धता/कैरेट',
      purity24k: '24k (24 कैरेट)',
      purity22k: '22k (22 कैरेट)',
      purity18k: '18k (18 कैरेट)',
      purityPure: 'शुद्ध',
      grossWeight: 'टोटल वजन (ग्राम में)',
      grossWeightPlaceholder: 'जैसे: 55.5',
      netWeight: 'शुद्ध वजन (ग्राम में)',
      netWeightPlaceholder: 'जैसे: 50.5',
      presentValue: 'वर्तमान मूल्य अमाउंट (₹)',
      presentValuePlaceholder: 'जैसे: 325000',
      autoCalculated: 'स्वचालित गणना',
      collateralPhotos: 'गिरवी सामान फोटो',
      uploadPhotos: 'फोटो अपलोड करें',
      uploadPhotosHint: 'गिरवी सामान की फोटो अपलोड करें (वैकल्पिक)',
      clickToUpload: 'अपलोड के लिए क्लिक करें',
      or: 'या',
      dragDrop: 'यहाँ खींचें और छोड़ें',
      supportedFormats: 'PNG, JPG, JPEG (अधिकतम 5MB प्रत्येक)',
      photoPreview: 'फोटो पूर्वावलोकन'
    },
    // Step 3: Loan Terms
    step3: {
      title: 'चरण 3: लोन की शर्तें',
      marketValue: 'बाजार मूल्य',
      maxEligibleAmount: 'अधिकतम योग्य अमाउंट',
      ltvRate: 'एलटीवी दर (प्रति ग्राम)',
      ltvRatePlaceholder: '6500',
      autoFilledLTV: '💡 स्वचालित रूप से भरा गया',
      lendingRate: 'लोन दर (प्रति ग्राम)',
      lendingRatePlaceholder: 'प्रति ग्राम दर',
      finalDisbursedAmount: 'अंतिम दी जाने वाली अमाउंट (₹)',
      disbursedAmount: 'दी जाने वाली अमाउंट (₹)',
      disbursedAmountPlaceholder: 'जैसे: 325000',
      interestRate: 'ब्याज दर (% प्रति महीना)',
      interestRatePlaceholder: '2.5',
      tenure: 'अवधि (महीनों में)',
      tenurePlaceholder: '12',
      calculatedInterest: 'गणना किया गया ब्याज',
      totalRepayment: 'टोटल वापसी अमाउंट'
    },
    // Step 4: Confirmation
    step4: {
      title: 'चरण 4: पुष्टि',
      reviewLoanDetails: 'लोन विवरण की समीक्षा करें',
      reviewMessage: 'कृपया लोन की पुष्टि करने से पहले सभी विवरण की समीक्षा करें। पुष्टि करने के बाद, लोन सिस्टम में बन जाएगा।',
      borrowerDetails: 'कस्टमर विवरण',
      collateralDetails: 'गिरवी सामान विवरण',
      loanTerms: 'लोन की शर्तें',
      noBorrowerSelected: '⚠️ कोई कस्टमर नहीं चुना गया। कृपया वापस जाएं और कस्टमर चुनें।',
      name: 'नाम',
      phone: 'फोन',
      email: 'ईमेल',
      address: 'पता',
      metalType: 'धातु का प्रकार',
      purityKarat: 'शुद्धता/कैरेट',
      grossWeight: 'टोटल वजन',
      netWeight: 'शुद्ध वजन',
      presentValueAmount: 'वर्तमान मूल्य अमाउंट',
      itemDescription: 'सामान का विवरण',
      serialNumber: 'सीरियल नंबर',
      creatingDate: 'लोन बनाने की तारीख',
      ltvRate: 'एलटीवी दर',
      lendingRate: 'लोन दर',
      disbursedAmount: 'दी जाने वाली अमाउंट',
      interestRate: 'ब्याज दर',
      tenure: 'अवधि',
      months: 'महीने',
      perMonth: 'प्रति महीना',
      perGram: 'प्रति ग्राम',
      calculatedInterest: 'गणना किया गया ब्याज',
      totalRepayment: 'टोटल वापसी अमाउंट',
      photos: 'फोटो',
      confirmCreateLoan: 'पुष्टि करें और लोन बनाओ'
    },
    // Buttons
    buttons: {
      back: 'पीछे',
      next: 'आगे',
      nextStep: 'अगला चरण',
      previous: 'पिछला',
      createLoan: 'लोन बनाओ',
      confirmCreateLoan: 'पुष्टि करें और लोन बनाओ',
      creating: 'बन रहा है...'
    },
    // Messages
    messages: {
      selectBorrower: 'कृपया कस्टमर चुनें या नया कस्टमर बनाओ',
      fillCollateralDetails: 'कृपया सभी आवश्यक गिरवी सामान विवरण भरें',
      selectCreatingDate: 'कृपया मान्य लोन बनाने की तारीख चुनें',
      fillLoanTerms: 'कृपया सभी लोन की शर्तें भरें',
      disbursedAmountExceeds: 'दी जाने वाली अमाउंट अधिकतम योग्य अमाउंट से अधिक नहीं हो सकती',
      uploadFailed: 'फोटो अपलोड विफल। कृपया पुनः प्रयास करें।',
      loanCreatedSuccess: 'लोन सफलतापूर्वक बनाया गया!',
      borrowerSelected: 'कस्टमर चुना गया। अब गिरवी सामान विवरण जोड़ें।'
    }
  },

  // Create Pledge Page - नई गिरवी सामान बनाओ  
  createPledge: {
    title: 'नई गिरवी सामान बनाओ',
    backToCollateral: 'गिरवी सामान सूची में वापस',
    // Form Fields
    loanId: 'लोन नंबर',
    loanNumber: 'लोन नंबर',
    loanIdPlaceholder: 'लोन नंबर, कस्टमर नाम, या फोन से सर्च करें...',
    selectedLoan: 'चुना गया लोन',
    borrower: 'कस्टमर',
    phone: 'फोन',
    amount: 'अमाउंट',
    serialNumber: 'सीरियल नंबर',
    pledgedTo: 'कहाँ गिरवी सामान',
    pledgedToPlaceholder: 'बैंक या संस्था का नाम',
    searchBank: 'बैंक सर्च करें...',
    selectOrType: 'सूची से चुनें या नया नाम लिखें',
    pledgeAmount: 'गिरवी सामान अमाउंट (₹)',
    pledgeAmountPlaceholder: 'गिरवी सामान अमाउंट दर्ज करें',
    interestRate: 'ब्याज दर (% प्रति महीना)',
    interestRatePlaceholder: 'ब्याज दर',
    pledgeDate: 'गिरवी सामान की तारीख',
    searchingLoans: 'लोन खोज रहे हैं...',
    noLoansFound: 'कोई लोन नहीं मिला',
    maturityDate: 'वापसी की तारीख',
    uploadDocument: 'दस्तावेज़ अपलोड करें',
    uploadDocumentHint: 'गिरवी सामान दस्तावेज़ अपलोड करें (वैकल्पिक)',
    clickToUpload: 'अपलोड के लिए क्लिक करें',
    or: 'या',
    dragDrop: 'यहाँ खींचें और छोड़ें',
    supportedFormats: 'PDF, PNG, JPG, JPEG (अधिकतम 10MB)',
    documentPreview: 'दस्तावेज़ पूर्वावलोकन',
    // Buttons
    buttons: {
      save: 'सेव करें',
      creating: 'बन रहा है...',
      uploading: 'अपलोड हो रहा...',
      createPledge: 'गिरवी सामान बनाओ'
    },
    // Messages
    messages: {
      selectLoan: 'कृपया लोन चुनें',
      fillAllFields: 'कृपया सभी आवश्यक फ़ील्ड भरें',
      pledgeCreatedSuccess: 'गिरवी सामान सफलतापूर्वक बनाई गई!',
      uploadFailed: 'दस्तावेज़ अपलोड विफल। कृपया पुनः प्रयास करें।',
      createFailed: 'गिरवी सामान बनाने में विफल',
      alreadyPledged: 'यह आइटम पहले से गिरवी है'
    }
  },

  // Collateral/Re-pledging Page - फिर से गिरवी सामान पृष्ठ
  collateral: {
    title: 'फिर से गिरवी सामान',
    listTitle: 'सभी फिर से गिरवी सामान',
    createNewPledge: 'नई गिरवी सामान रखें',
    bankSummary: {
      button: 'बैंक सारांश',
      title: 'बैंक सारांश',
      subtitle: 'बैंक के अनुसार गिरवी सामान का विवरण',
      loading: 'बैंक सारांश लोड हो रहा है...',
      loadError: 'बैंक सारांश लोड नहीं हो पाया',
      retry: 'फिर कोशिश करें',
      emptyTitle: 'कोई गिरवी सामान नहीं मिली',
      emptyMessage: 'सारांश दिखाने के लिए अभी कोई गिरवी सामान नहीं है।',
      perMonth: 'प्रति माह',
      pledgedLoans: 'गिरवी लोन',
      pledgedAmount: 'गिरवी अमाउंट',
      interestPaid: 'भुगतान ब्याज',
      interestDue: 'देय ब्याज',
      viewLoans: '{count} लोन देखें →',
      totalSummary: 'कुल सारांश',
      activeTotalSummary: 'बैंक में सक्रिय',
      activeTotalHint: 'केवल PLEDGED + AWAITING',
      allTimeTotalSummary: 'कुल अब तक',
      allTimeTotalHint: 'HISTORY',
      loansBadge: '{count} लोन',
      totalLoans: 'कुल लोन',
      totalPledgedAmount: 'कुल गिरवी अमाउंट',
      totalInterestPaid: 'कुल भुगतान ब्याज',
      totalInterestDue: 'कुल देय ब्याज'
    },
    pledgeId: 'गिरवी सामान नंबर',
    itemName: 'सामान का नाम',
    weight: 'वजन',
    value: 'कीमत',
    status: 'स्थिति',
    pledgedDate: 'गिरवी सामान की तारीख',
    viewDetails: 'पूरा विवरण',
    noPledgesFound: 'कोई गिरवी सामान नहीं मिली',
    searchPlaceholder: 'गिरवी सामान सर्च करें...',
    searchPlaceholderDetailed: 'कस्टमर, लोन नंबर या कहाँ गिरवी सामान है उससे सर्च करें...',
    filterLabel: 'सभी स्थिति',
    tableHeaders: {
      loanId: 'लोन नंबर',
      borrower: 'कस्टमर',
      pledgedTo: 'कहाँ गिरवी सामान',
      pledgeAmount: 'गिरवी सामान अमाउंट',
      interestRate: 'ब्याज दर',
      pledgeDate: 'गिरवी सामान की तारीख',
      maturityDate: 'समाप्ति की तारीख',
      status: 'स्थिति'
    },
    statusOptions: {
      all: 'सभी स्थिति',
      inHand: 'दुकान में',
      pledged: 'गिरवी सामान',
      awaiting: 'इंतज़ार में',
      handover: 'वापस दिया'
    },
    loadingMessage: 'गिरवी सामान लोड हो रही है...',
    emptyState: 'कोई गिरवी सामान नहीं मिली',
    errors: {
      noBusinessSelected: 'कोई दुकान नहीं चुनी',
      loadFailed: 'गिरवी सामान लोड नहीं हो पाई',
      updateFailed: 'स्थिति बदलने में दिक्कत आई'
    },
    statusModal: {
      title: 'स्थिति चेंज करें',
      messageStart: 'क्या आप स्थिति बदलना चाहते हैं',
      from: 'से',
      to: 'को',
      defaultName: 'इस गिरवी सामान',
      cancel: 'कैंसल करें',
      confirm: 'स्थिति चेंज करें',
      updating: 'बदला जा रहा है...'
    }
  },

  // Loan Details Page - लोन विवरण पृष्ठ
  loanDetails: {
    loading: 'लोन डिटेल लोड हो रही है...',
    notFound: 'लोन नहीं मिला',
    backToList: 'लोन सूची पर वापस',
    back: 'वापस',
    recordPayment: 'भुगतान जोड़ें',
    additionalLoan: 'अतिरिक्त लोन',
    additionalAdvance: 'अतिरिक्त एडवांस',
    roundOff: 'राउंड-ऑफ',
    settlementAdjustment: 'सेटलमेंट समायोजन',
    paymentAllocation: 'भुगतान आवंटन',
    additionalDisbursement: 'अतिरिक्त वितरण',
    initialDisbursement: 'प्रारंभिक वितरण',
    payment: 'भुगतान',
    advanceLedger: 'लोन एडवांस',
    advanceDate: 'एडवांस तारीख',
    advanceAmount: 'एडवांस अमाउंट',
    maximumEligibleAmount: 'अधिकतम योग्य अमाउंट',
    currentTotalAdvanced: 'अभी तक कुल एडवांस',
    currentInterestRate: 'वर्तमान ब्याज दर',
    remainingEligibleAmount: 'बाकी योग्य अमाउंट',
    outstandingPrincipal: 'बाकी मूलधन',
    outstandingInterest: 'बाकी ब्याज',
    noAdvances: 'कोई एडवांस रिकॉर्ड नहीं',
    saveAdditionalLoan: 'लोन जोड़ें',
    addingAdditionalLoan: 'जोड़ा जा रहा है...',
    summaryTitle: 'लोन सारांश',
    borrowerLabel: 'कस्टमर',
    principalLabel: 'लोन अमाउंट',
    interestLabel: 'जमा ब्याज',
    durationLabel: 'लोन अवधि',
    durationUnit: 'महीने',
    durationSingleUnit: 'महीना',
    interestRow: 'ब्याज',
    interestPerMonth: 'प्रति महीना',
    principalOutstanding: 'लोन अमाउंट',
    totalDue: 'टोटल देय',
    borrowerCardTitle: 'कस्टमर विवरण',
    borrowerContact: 'मोबाइल नंबर',
    borrowerEmail: 'ईमेल',
    borrowerAddress: 'पता',
    pledgeCardTitle: 'गिरवी सामान विवरण',
    pledgeStatus: 'गिरवी सामान स्थिति',
    pledgedTo: 'कहाँ गिरवी सामान',
    pledgeDate: 'गिरवी सामान की तारीख',
    maturityDate: 'समाप्ति की तारीख',
    collateralStatus: 'स्थिति',
    paymentHistory: 'भुगतान का रिकॉर्ड',
    // Transaction Ledger (Khata)
    transactionLedger: 'ट्रांजैक्शन अकाउंट (अकाउंट)',
    ledgerTitle: 'अकाउंट बही',
    loadingTransactions: 'ट्रांजैक्शन लोड हो रहा...',
    noTransactionsFound: 'कोई ट्रांजैक्शन नहीं मिला',
    ledgerHeaders: {
      date: 'तारीख',
      description: 'विवरण',
      reference: 'संदर्भ',
      paymentMethod: 'भुगतान का तरीका',
      roundOff: 'राउंड-ऑफ',
      amount: 'अमाउंट'
    },
    // Item Details
    itemDetails: 'सामान का विवरण',
    metalType: 'धातु का प्रकार',
    purity: 'शुद्धता',
    grossWeight: 'टोटल वजन',
    netWeight: 'शुद्ध वजन',
    presentValue: 'वर्तमान मूल्य',
    lendingRate: 'लोन दर',
    serialNumber: 'सीरियल नंबर',
    collateralImage: 'गिरवी सामान फोटो',
    // Collateral Status
    collateralStatusValues: {
      IN_HAND: 'दुकान में',
      PLEDGED: 'गिरवी सामान',
      AWAITING: 'वापसी का इंतज़ार',
      HANDOVER: 'वापस दिया'
    },
    paymentTable: {
      noPayments: 'अभी तक कोई भुगतान नहीं',
      headers: {
        date: 'तारीख',
        amount: 'अमाउंट',
        interest: 'ब्याज',
        penalty: 'जुर्माना',
        mode: 'भुगतान का तरीका',
        reference: 'संदर्भ',
        notes: 'नोट',
        actions: 'ऑप्शन'
      },
      viewReceipt: 'रसीद देखें',
      delete: 'डिलीट करें'
    },
    paymentModal: {
      title: 'भुगतान जोड़ें',
      paymentSummary: 'भुगतान सारांश',
      totalAmountDue: 'टोटल देय अमाउंट',
      totalPaid: 'टोटल दिया',
      outstandingBalance: 'बाकी अमाउंट',
      roundOffAmount: 'राउंड-ऑफ अमाउंट (स्वचालित)',
      paymentAmount: 'भुगतान अमाउंट',
      enterPaymentAmount: 'भुगतान अमाउंट दर्ज करें',
      maximum: 'अधिकतम',
      paymentMethod: 'भुगतान का तरीका',
      referenceNumber: 'संदर्भ नंबर (वैकल्पिक)',
      enterReference: 'संदर्भ/ट्रांजैक्शन नंबर दर्ज करें',
      description: 'विवरण',
      interestPayment: 'ब्याज भुगतान',
      loanDisbursed: 'लोन दिया',
      principalPayment: 'मूल अमाउंट भुगतान',
      partialPayment: 'आंशिक भुगतान',
      cancel: 'कैंसल करें',
      recordPayment: 'भुगतान दर्ज करें',
      recording: 'दर्ज हो रहा है...',
      paymentType: 'भुगतान का प्रकार',
      regularPayment: 'नियमित भुगतान',
      interestOnly: 'केवल ब्याज',
      fullSettlement: 'पूरा भुगतान',
      interestAllocation: 'ब्याज में',
      principalAllocation: 'मूलधन में',
      expectedSettlement: 'पूरा भुगतान अमाउंट',
      enterDescription: 'वैकल्पिक नोट',
      // Payment Methods
      cash: 'नकद',
      upi: 'यूपीआई',
      bankTransfer: 'बैंक ट्रांसफर',
      cheque: 'चेक',
      card: 'कार्ड',
      // Old fields for backward compatibility
      amountLabel: 'अमाउंट',
      methodLabel: 'भुगतान का तरीका',
      descriptionLabel: 'विवरण',
      referenceLabel: 'संदर्भ नंबर',
      close: 'बंद करें',
      save: 'भुगतान सेव करें'
    },
    statusModal: {
      title: 'गिरवी सामान स्थिति चेंज करें',
      message: 'क्या गिरवी सामान सामान वापस आ गया है?',
      cancel: 'कैंसल करें',
      confirm: 'पुष्टि करें',
      updating: 'बदला जा रहा है...'
    },
    deleteLoanModal: {
      title: 'लोन डिलीट करें',
      message: 'क्या आप यह लोन हटाना चाहते हैं? यह वापस नहीं हो सकता।',
      confirm: 'लोन डिलीट करें',
      cancel: 'कैंसल करें'
    },
    deletePaymentModal: {
      title: 'भुगतान डिलीट करें',
      message: 'क्या आप यह भुगतान हटाना चाहते हैं?',
      confirm: 'भुगतान डिलीट करें',
      cancel: 'कैंसल करें'
    },
    messages: {
      loadError: 'लोन डिटेल लोड नहीं हो पाई',
      pledgesLoadError: 'गिरवी सामान लोड नहीं हो पाई',
      paymentsLoadError: 'भुगतान लोड नहीं हो पाए',
      statusUpdateSuccess: 'गिरवी सामान वापस आ गई और लोन बंद हुआ।',
      statusUpdateError: 'स्थिति नहीं बदली, कृपया फिर कोशिश करें।',
      paymentCreateSuccess: 'भुगतान सुरक्षित हो गया',
      paymentCreateError: 'भुगतान सुरक्षित नहीं हो पाया',
      paymentDeleteSuccess: 'भुगतान हटाया गया',
      paymentDeleteError: 'भुगतान हटाने में दिक्कत आई',
      paymentAmountInvalid: 'कृपया सही भुगतान अमाउंट लिखें',
      missingBusiness: 'दुकान या लोन की डिटेल नहीं मिली',
      advanceAmountInvalid: 'कृपया सही एडवांस अमाउंट लिखें',
      advanceCreateSuccess: 'अतिरिक्त लोन जुड़ गया',
      advanceCreateError: 'अतिरिक्त लोन नहीं जुड़ पाया'
    }
  },

  // Borrower Details Page - कस्टमर विवरण पृष्ठ
  borrowerDetails: {
    loading: 'कस्टमर डिटेल लोड हो रही है...',
    notFound: 'कस्टमर नहीं मिला',
    back: 'वापस',
    backToList: 'कस्टमर सूची पर वापस',
    headerId: 'कस्टमर नंबर',
    infoTitle: 'कस्टमर डिटेल',
    labels: {
      fullName: 'पूरा नाम',
      fatherName: 'पिता का नाम',
      contactNumber: 'मोबाइल नंबर',
      email: 'ईमेल',
      idProofType: 'पहचान पत्र का प्रकार',
      idProofNumber: 'पहचान पत्र नंबर',
      address: 'पता',
      createdDate: 'बनने की तारीख'
    },
    documents: {
      title: 'पहचान पत्र',
      expand: 'बड़ा करें',
      none: 'कोई दस्तावेज़ नहीं'
    },
    loans: {
      title: 'लोन का रिकॉर्ड',
      loading: 'लोन लोड हो रहे हैं...',
      empty: 'इस कस्टमर का कोई लोन नहीं मिला',
      headers: {
        loanId: 'लोन नंबर',
        serialNumber: 'सीरियल नंबर',
        principal: 'लोन अमाउंट (₹)',
        interestRate: 'ब्याज दर',
        tenure: 'अवधि',
        status: 'स्थिति',
        createdDate: 'बनने की तारीख',
        actions: 'ऑप्शन'
      },
      perMonth: 'प्रति महीना',
      months: 'महीने',
      view: 'पूरा विवरण'
    },
    messages: {
      loadError: 'कस्टमर डिटेल लोड नहीं हो पाई',
      loansError: 'लोन लोड नहीं हो पाए'
    },
    modal: {
      close: 'बंद करें',
      previous: 'पिछला',
      next: 'अगला'
    }
  },

  // Pledge Details Page - गिरवी सामान विवरण पृष्ठ
  pledgeDetails: {
    loading: 'गिरवी सामान डिटेल लोड हो रही है...',
    notFound: 'गिरवी सामान नहीं मिली',
    back: 'वापस',
    backToList: 'गिरवी सामान सूची पर वापस',
    statusBadge: 'स्थिति',
    summaryTitle: 'गिरवी सामान सारांश',
    borrowerTitle: 'कस्टमर विवरण',
    loanTitle: 'जुड़ा लोन',
    pledgedAmount: 'गिरवी सामान अमाउंट',
    interestRate: 'ब्याज दर',
    pledgeDate: 'गिरवी सामान की तारीख',
    maturityDate: 'समाप्ति की तारीख',
    pledgedTo: 'कहाँ गिरवी सामान',
    interestEarned: 'जमा ब्याज',
    totalDue: 'टोटल देय',
    pledgeDuration: 'गिरवी सामान अवधि',
    interestBreakdownTitle: 'ब्याज विवरण',
    additionalDaysLabel: 'दिन',
    netProfit: 'मासिक मुनाफा',
    updateStatus: 'वापस मार्क करें',
    // Interest Breakdown
    interestBreakdown: 'ब्याज विवरण',
    calculationDetails: 'गणना का विवरण:',
    oneMonthInterest: 'महीने का ब्याज',
    additionalDaysInterest: 'अतिरिक्त दिनों का ब्याज',
    totalInterestPayable: 'टोटल देय ब्याज',
    days: 'दिन',
    currentInterestTitle: 'वर्तमान ब्याज',
    interestPeriod: 'अवधि',
    interestDuration: 'दिन',
    interestDue: 'देय ब्याज',
    interestPaid: 'भुगतान ब्याज',
    interestOutstanding: 'बकाया',
    interestStatus: 'स्थिति',
    interestStatusPaid: 'भुगतान',
    interestStatusUnpaid: 'अवैतनिक',
    payInterest: 'ब्याज भुगतान',
    interestHistoryTitle: 'ब्याज भुगतान इतिहास',
    interestHistoryDate: 'तारीख',
    interestHistoryPeriod: 'अवधि',
    interestHistoryDays: 'दिन',
    interestHistoryAmount: 'राशि',
    interestHistoryStatus: 'स्थिति',
    interestPayModal: {
      title: 'गिरवी ब्याज भुगतान',
      message: 'वर्तमान ब्याज अवधि के लिए {amount} का भुगतान कन्फर्म करें।',
      cancel: 'कैंसल करें',
      confirm: 'ब्याज भुगतान',
      paying: 'भुगतान हो रहा है...'
    },
    // Associated Loan
    associatedLoan: 'जुड़ा हुआ लोन',
    loanId: 'लोन नंबर',
    loanAmount: 'लोन अमाउंट',
    loanStatus: 'लोन स्थिति',
    metalType: 'धातु का प्रकार',
    itemDescription: 'सामान का विवरण',
    viewLoan: 'लोन देखें',
    viewFullLoanDetails: 'पूरा लोन विवरण देखें',
    // Pledge Document
    pledgeDocument: 'गिरवी सामान दस्तावेज़',
    noDocumentAvailable: 'कोई दस्तावेज़ उपलब्ध नहीं',
    statusModal: {
      title: 'वापसी की पुष्टि',
      message: 'क्या गिरवी सामान सामान कस्टमर को वापस दे दिया है?',
      cancel: 'कैंसल करें',
      confirm: 'हाँ, वापस कर दें',
      updating: 'बदला जा रहा है...'
    },
    messages: {
      loadError: 'गिरवी सामान डिटेल लोड नहीं हो पाई',
      loanLoadError: 'जुड़ा लोन लोड नहीं हो पाया',
      statusSuccess: 'गिरवी सामान वापस आ गई और लोन बंद हुआ।',
      statusError: 'स्थिति नहीं बदली, कृपया फिर कोशिश करें।',
      noBusiness: 'कोई दुकान नहीं चुनी',
      noRecords: 'कोई गिरवी सामान रिकॉर्ड नहीं मिला',
      interestPaySuccess: 'गिरवी ब्याज सफलतापूर्वक भुगतान हो गया।',
      interestPayError: 'गिरवी ब्याज भुगतान नहीं हो पाया। फिर से कोशिश करें।'
    }
  },
  
  // SEO Keywords and Content - एसईओ कीवर्ड और सामग्री
  seo: {
    // Primary Keywords - प्राथमिक कीवर्ड
    primaryKeywords: [
      'गोल्ड लोन मैनेजमेंट सॉफ्टवेयर',
      'सोने पर लोन सॉफ्टवेयर',
      'गहनों पर लोन सिस्टम',
      'चांदी लोन सॉफ्टवेयर',
      'सोने के बदले लोन',
      'आभूषण लोन प्रबंधन',
      'गिरवी लोन सॉफ्टवेयर',
      'गिरवी सामान प्रबंधन सॉफ्टवेयर',
      'साहूकार सॉफ्टवेयर',
      'सोने की दुकान सॉफ्टवेयर',
      'गहनों का कारोबार सॉफ्टवेयर'
    ],
    
    // Secondary Keywords - द्वितीयक कीवर्ड
    secondaryKeywords: [
      'गोल्ड लोन कैलकुलेटर',
      'सोने का भाव कैलकुलेटर',
      'ब्याज कैलकुलेटर लोन',
      'लोन मैनेजमेंट सिस्टम',
      'कस्टमर लोन ट्रैकिंग',
      'उधारकर्ता प्रबंधन',
      'लोन चुकौती ट्रैकर',
      'सोने की शुद्धता कैलकुलेटर',
      '22 कैरेट सोने पर लोन',
      '24 कैरेट सोने पर लोन',
      '18 कैरेट सोने पर लोन',
      'हॉलमार्क गोल्ड लोन',
      'भारतीय गोल्ड लोन सॉफ्टवेयर',
      'छोटे व्यापार लोन सॉफ्टवेयर',
      'एमएसएमई लोन सॉफ्टवेयर',
      'सूक्ष्म वित्त सॉफ्टवेयर',
      'फिर से गिरवी सॉफ्टवेयर',
      'लोन बुक सॉफ्टवेयर',
      'खाता बही लोन के लिए',
      'डिजिटल लोन प्रबंधन',
      'ऑनलाइन गोल्ड लोन',
      'सोने की दुकान सॉफ्टवेयर',
      'ज्वेलरी स्टोर लोन सिस्टम',
      'गिरवी दुकान सॉफ्टवेयर'
    ],
    
    // Location-Based Keywords - स्थान आधारित कीवर्ड
    locationKeywords: [
      'जयपुर गोल्ड लोन',
      'जोधपुर गोल्ड लोन',
      'राजस्थान गोल्ड लोन',
      'दिल्ली गोल्ड लोन',
      'मुंबई गोल्ड लोन',
      'भारत गोल्ड लोन',
      'राजस्थान व्यापार सॉफ्टवेयर',
      'मारवाड़ी व्यापार सॉफ्टवेयर',
      'राजस्थानी साहूकार सॉफ्टवेयर'
    ],
    
    // Long-Tail Keywords - लंबी पूंछ वाले कीवर्ड
    longTailKeywords: [
      'गोल्ड लोन बिजनेस कैसे मैनेज करें',
      'बेस्ट गोल्ड लोन मैनेजमेंट सॉफ्टवेयर',
      'ज्वेलरी लोन बिजनेस के लिए सॉफ्टवेयर',
      'सोने के लोन के लिए डिजिटल समाधान',
      'गोल्ड लोन कस्टमर को कैसे ट्रैक करें',
      'ऑनलाइन गिरवी लोन मैनेज करें',
      'गोल्ड लोन ब्याज कैलकुलेटर',
      'साहूकार बिजनेस के लिए सॉफ्टवेयर',
      'छोटे बिजनेस के लिए लोन प्रबंधन',
      'सोने के गिरवी सामान प्रबंधन सिस्टम',
      'सोने पर कितना लोन मिलता है',
      'गोल्ड लोन की ब्याज दर',
      'गहनों पर लोन कैसे लें'
    ],
    
    // Meta Descriptions - मेटा विवरण
    metaDescriptions: {
      home: 'संपूर्ण गोल्ड और सिल्वर लोन मैनेजमेंट सॉफ्टवेयर। सोने के लोन, गहनों के लोन, गिरवी लोन और कोलैटरल को आसानी से मैनेज करें। भारत और राजस्थान में गोल्ड लोन बिजनेस, गिरवी दुकानों और ज्वेलरी फाइनेंस कंपनियों के लिए परफेक्ट।',
      features: 'लोन ट्रैक करें, उधारकर्ताओं को मैनेज करें, गिरवी संभालें, ब्याज की गणना करें, रिपोर्ट जनरेट करें और हमारे व्यापक प्रबंधन सॉफ्टवेयर के साथ अपने गोल्ड लोन बिजनेस को बढ़ाएं।',
      benefits: 'स्वचालित गणना, कस्टमर ट्रैकिंग, भुगतान प्रबंधन और विस्तृत एनालिटिक्स के साथ अपने गोल्ड लोन बिजनेस संचालन को सुव्यवस्थित करें। भारत भर के बिजनेस द्वारा विश्वसनीय।'
    },
    
    // Page Titles - पेज शीर्षक
    pageTitles: {
      home: 'गोल्ड लोन मैनेजमेंट सॉफ्टवेयर | ज्वेलरी लोन सिस्टम | बेस्ट लोन सॉफ्टवेयर',
      dashboard: 'लोन डैशबोर्ड | गोल्ड लोन, कस्टमर और भुगतान ट्रैक करें',
      loans: 'गोल्ड लोन मैनेज करें | ज्वेलरी लोन ट्रैकिंग | लोन प्रबंधन',
      borrowers: 'कस्टमर मैनेजमेंट | उधारकर्ता ट्रैकिंग | गोल्ड लोन ग्राहक',
      collateral: 'गिरवी सामान प्रबंधन | प्लेज ट्रैकिंग | री-प्लेजिंग सिस्टम',
      analytics: 'लोन एनालिटिक्स | बिजनेस रिपोर्ट | लाभप्रदता विश्लेषण',
      settings: 'गोल्ड रेट सेटिंग्स | ब्याज दरें | लोन कॉन्फ़िगरेशन'
    }
  },
  
  profile: {
    businessProfile: 'व्यवसाय प्रोफ़ाइल',
    editBusinessProfile: 'व्यवसाय प्रोफ़ाइल चेंज करें',
    businessName: 'व्यवसाय नाम',
    contactNumber: 'संपर्क नंबर',
    businessAddress: 'व्यवसाय पता',
    noLogo: 'कोई लोगो नहीं',
    uploading: 'अपलोड हो रहा...',
    change: 'चेंज करें',
    upload: 'अपलोड करें',
    imageFormat: 'PNG, JPG अधिकतम 5MB',
    cancel: 'कैंसल करें',
    saveBusinessProfile: 'व्यवसाय प्रोफ़ाइल सहेजें',
    saving: 'सहेजा जा रहा है...',
    
    userProfile: 'उपयोगकर्ता प्रोफ़ाइल',
    editProfile: 'प्रोफ़ाइल चेंज करें और पासवर्ड चेंज करें',
    firstName: 'पहला नाम',
    lastName: 'अंतिम नाम',
    email: 'ईमेल',
    role: 'भूमिका',
    previousPassword: 'पुराना पासवर्ड',
    newPassword: 'नया पासवर्ड',
    enterCurrentPassword: 'अपना वर्तमान पासवर्ड दर्ज करें',
    enterNewPassword: 'अपना नया पासवर्ड दर्ज करें',
    saveChanges: 'परिवर्तन सहेजें',
    
    logout: 'लॉगआउट',
    
    errors: {
      invalidImage: 'कृपया एक वैध छवि फ़ाइल चुनें।',
      imageSizeLimit: 'छवि का आकार 5MB से कम होना चाहिए।',
      uploadFailed: 'लोगो अपलोड करने में विफल',
      businessIdNotFound: 'व्यवसाय ID नहीं मिली। कृपया पृष्ठ रीफ्रेश करें।',
      contactRequired: 'संपर्क नंबर आवश्यक है।',
      addressRequired: 'व्यवसाय पता आवश्यक है।',
      updateBusinessFailed: 'व्यवसाय प्रोफ़ाइल अपडेट करने में विफल। कृपया पुनः प्रयास करें।',
      updateBusinessError: 'व्यवसाय प्रोफ़ाइल अपडेट करने में त्रुटि हुई। कृपया पुनः प्रयास करें।',
      userIdNotFound: 'उपयोगकर्ता ID नहीं मिली। कृपया फिर से लॉगिन करें।',
      passwordFieldsRequired: 'पासवर्ड बदलने के लिए पुराना और नया पासवर्ड दोनों आवश्यक हैं।',
      passwordMinLength: 'नया पासवर्ड कम से कम 6 अक्षरों का होना चाहिए।',
      updateProfileFailed: 'प्रोफ़ाइल अपडेट करने में विफल। कृपया पुनः प्रयास करें।',
      updateProfileError: 'प्रोफ़ाइल अपडेट करने में त्रुटि हुई। कृपया पुनः प्रयास करें।'
    }
  }
};
